import { Callout } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { WorkspaceScheduleJob } from "@/types/workspaces";
import { formatDate } from "@/utils/datetime";

interface InvitationsScheduledBannerProps {
  onOpenInvitationDetail: (scheduleJob: WorkspaceScheduleJob) => void;
  scheduleJob?: WorkspaceScheduleJob | null;
}

export function InvitationsScheduledBanner({
  onOpenInvitationDetail,
  scheduleJob,
}: InvitationsScheduledBannerProps) {
  if (!scheduleJob) return null;

  const { scheduledAt } = scheduleJob;
  return (
    <Callout intent="primary" icon={null}>
      <Box color={"#215DB0"}>
        Invitations scheduled for{" "}
        <b>{formatDate(scheduledAt, "MMM d, yyyy 'at' hh:mm a z")}</b>. No
        communication is sent until then.
        <br />
      </Box>
      <a
        onClick={(event) => {
          event.preventDefault();
          onOpenInvitationDetail(scheduleJob);
        }}
        style={{ textDecoration: "none" }}
      >
        Change Plan
      </a>
    </Callout>
  );
}
